import { AddressEmail } from './AddressEmail'
import { AddressPhoneNumber } from './AddressPhoneNumber'

export type AddressContactProps = UiComponentProps & {
  /** The phone number associated with the address */
  phone?: string | null
  /** The email associated with the address */
  email?: string | null
  /** The function to call when the phone is pressed */
  onPhonePress?: () => void
}

export function AddressContact({
  phone,
  email,
  onPhonePress,
  'data-testid': dataTestid,
}: AddressContactProps) {
  if (!phone && !email) return null

  return (
    <div className="mt-2 flex flex-col gap-1" data-testid={dataTestid}>
      {phone && (
        <AddressPhoneNumber
          phone={phone}
          data-testid={`${dataTestid}/phone-number`}
          onPhonePress={onPhonePress}
        />
      )}
      {email && <AddressEmail email={email} data-testid={`${dataTestid}/email`} />}
    </div>
  )
}
